// extracted by mini-css-extract-plugin
export default {"container":"Test_container__H12ts","content":"Test_content__3m55R","greetings":"Test_greetings__Ub9Le","intro":"Test_intro__I+Nvu","start":"Test_start__NwYXq"};